import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

const useStyles = makeStyles(({
	link: {
		width: "fit-content"
	},
	portlet: {
		margin: "60px 0"
	},
	container: {
		display: "flex"
	},
	bodyText: {
		fontSize: "18px",
		textAlign: "center",
		color: colors.gray[50]
	},
	bodyAuxiliarText: {
		fontSize: "18px",
		textAlign: "center",
		marginTop: "20px",
		color: themeColors.colors.base.white
	},
	button: {
		margin: "30px auto",
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.base.white),
		width: "300px",
		padding: "18px 40px",
		borderRadius: "50px",
		color: themeColors.getPrimaryColor()
	},
	calloutTitle: {
		fontSize: "40px",
		color: themeColors.getPrimaryColor(),
		fontWeight: 600,
		lineHeight: "normal",
		marginBottom: "20px"
	},
	calloutImage: {
		width: "-webkit-fill-available"
	},
	listedItem: {
		marginTop: "5px"
	},
	bannerContainer: {
		margin: "40px 0"
	},
	bannerImg: {
		width: "100%",
		height: "100%",
		objectFit: "cover",
		maxWidth: "100%"
	}
}))

export default useStyles
